import { render, staticRenderFns } from "./overFile.vue?vue&type=template&id=6d77341c&scoped=true&"
import script from "./overFile.vue?vue&type=script&lang=js&"
export * from "./overFile.vue?vue&type=script&lang=js&"
import style0 from "./overFile.vue?vue&type=style&index=0&id=6d77341c&scoped=true&lang=css&"
import style1 from "./overFile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d77341c",
  null
  
)

export default component.exports